/*
 *
 * AssignedForm12970
 *
 */
import { AssignedForm } from 'pages/Requests/AssignedView';
import { IN_PROGRESS } from 'domain/Data/RequestStatus/constants';
import { SERVICE } from 'domain/Data/RequestType/constants';

class AssignedForm12970 extends AssignedForm {
  getFields() {
    const currentDate = new Date();

    return [
      {
        name: 'author',
        visible: false,
        initialValue: (values, mode, user) => user.id,
      },
      {
        name: 'assignee',
        visible: false,
        initialValue: (values, mode, user) => user.id,
      },
      {
        name: 'customer',
        visible: false,
        initialValue: (values, mode, user) => user.id,
      },
      {
        name: 'company',
        visible: false,
        initialValue: (values, mode, user) => user.companyId,
        numberInQueueFromEnd: 1,
      },
      {
        name: 'number',
        label: '№',
        visible: (currentValues, initialValues, mode) => mode === 'view',
      },
      {
        name: 'status',
        label: 'Статус',
        entityName: 'requestStatuses',
        visible: false,
        calculatedValue: (values, mode) => {
          if (mode === 'add' || mode === 'copy') { return IN_PROGRESS; }

          return values.status;
        },
        disabled: (currentValues, initialValues, mode) => !!((mode === 'view' || mode === 'edit')),
        orderBy: 'name',
        required: true,
      },
      {
        name: 'type',
        type: 'select',
        label: 'Вид',
        required: true,
        entityName: 'requestTypes',
        initialValue: () => SERVICE,
        visibleOptions: () => [SERVICE],
        orderBy: 'order',
        clearErrorsOnChange: true,
      },
      {
        name: 'visitDate',
        type: 'date',
        label: 'Дата',
        rowBreakBefore: true,
        required: true,
        visible: true,
        initialValue: currentDate,
        min: (currentValues, initialValues) => new Date(initialValues.visitDate) < currentDate ?
          new Date(initialValues.visitDate) : currentDate,
        disabled: true,
        calculatedValue: (values) => {
          const visitDate = new Date(values.visitDate);
          return new Date(visitDate.getFullYear(), visitDate.getMonth(), visitDate.getDate(), currentDate.getHours()
          )
        },
      },
      {
        name: 'service',
        type: 'select',
        label: 'Сервис',
        entityName: 'services',
        visible: true,
        rowBreakBefore: true,
      },
      {
        name: 'whereHappened',
        label: 'Где произошло',
        entityName: 'services',
        visible: (values) => values.type === SERVICE,
      },
      {
        name: 'whatHappened',
        label: 'Что нужно сделать',
        multiline: false,
        visible: (values) => values.type === SERVICE,
        grid: { sm: 12 },
        required: true,
      },
      {
        name: 'executionTerm',
        type: 'date',
        label: 'Срок исполнения',
        visible: true,
        rowBreakBefore: true,
        min: () => currentDate,
        calculatedValue: (values, mode) => {
          if (mode === 'copy') return null;
          return values.executionTerm;
        },
        disabled: (currentValues, initialValues, mode) => !!((mode === 'view' || mode === 'edit')),
      },
      {
        name: 'executionDate',
        type: 'date',
        label: 'Дата выполнения факт',
        visible: true,
        min: (currentValues, initialValues) => new Date(initialValues.visitDate) < currentDate ?
          new Date(initialValues.visitDate) : currentDate,
        calculatedValue: (values, mode) => {
          if (mode === 'copy') return null;
          return values.executionDate;
        },
        disabled: (currentValues, initialValues, mode) => !!((mode === 'view' || mode === 'edit')),
      },
      {
        name: 'implementationReport',
        label: 'Отчет о выполнении',
        visible: true,
        grid: { sm: 12 },
        calculatedValue: (values, mode) => {
          if (mode === 'copy') return null;
          return values.implementationReport;
        },
        disabled: (currentValues, initialValues, mode) => !!(mode === 'view'),
      },
      {
        name: 'note',
        label: 'Примечание',
        grid: { sm: 12 },
        visible: true,
        initialValue: (values, mode) => {
          if (mode === 'copy') return null;
          return values.note;
        },
      },
      {
        name: 'file',
        label: 'Файл',
        type: 'file',
        visible: true,
        rowBreakBefore: true,
      },
    ];
  }
}

export default AssignedForm12970;
